/**
 * What the desktop shell (desktop/) offers the page, read from `window.electronDesktop`,
 * which desktop/preload.js exposes. In a normal browser it is absent.
 */

function bridge() {
  return typeof window !== 'undefined' ? window.electronDesktop : undefined;
}

/** True when the page runs inside the desktop shell. */
export function inDesktopShell() {
  return !!bridge();
}

/**
 * True when a `beforeunload` handler that cancels the unload gets a Leave / Stay prompt:
 * always in a browser; in the desktop shell only when it declares `unloadPrompt`
 * (desktop/unloadPrompt.js). An older shell cancels the close, reload, quit or update
 * restart without showing anything, so a page there must not cancel its unload.
 */
export function canPromptOnUnload() {
  const b = bridge();
  return !b || b.unloadPrompt === true;
}
